import { useFormContext } from 'react-hook-form';

import { FormFieldRenderer } from '../components';
import { signaturesVerificationFieldGroups } from '../data';
import { IArrestFormData } from '../types';

interface SignaturesVerificationTabProps {
  viewMode?: boolean;
}

const SignaturesVerificationTab = ({
  viewMode = false,
}: SignaturesVerificationTabProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IArrestFormData>();

  return (
    <div className="space-y-4 w-full">
      {signaturesVerificationFieldGroups.map((group, groupIndex) => (
        <div key={`group-${groupIndex}`}>
          <div className="grid grid-cols-12 gap-4">
            {group.fields.map((field) => (
              <FormFieldRenderer
                key={field.name}
                field={field}
                control={control}
                errors={errors}
                viewMode={viewMode}
              />
            ))}
          </div>
          {groupIndex < signaturesVerificationFieldGroups.length - 1 && (
            <hr className="my-6 border-gray-300 dark:border-gray-600" />
          )}
        </div>
      ))}
    </div>
  );
};

export default SignaturesVerificationTab;
